import { useId } from 'react';

const DuplicateIconV1 = () => {
  const clipPathId = useId();
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d='M13 0H8.33333C6.67933 0 5.33333 1.346 5.33333 3V7.66667C5.33333 9.32067 6.67933 10.6667 8.33333 10.6667H13C14.654 10.6667 16 9.32067 16 7.66667V3C16 1.346 14.654 0 13 0ZM14 7.66667C14 8.218 13.5513 8.66667 13 8.66667H8.33333C7.782 8.66667 7.33333 8.218 7.33333 7.66667V3C7.33333 2.44867 7.782 2 8.33333 2H13C13.5513 2 14 2.44867 14 3V7.66667ZM10.6667 13C10.6667 14.654 9.32067 16 7.66667 16H3C1.346 16 0 14.654 0 13V8.33333C0 6.67933 1.346 5.33333 3 5.33333C3.552 5.33333 4 5.78067 4 6.33333C4 6.886 3.552 7.33333 3 7.33333C2.448 7.33333 2 7.782 2 8.33333V13C2 13.5513 2.44867 14 3 14H7.66667C8.218 14 8.66667 13.5513 8.66667 13C8.66667 12.4487 9.11467 12 9.66667 12C10.2187 12 10.6667 12.4473 10.6667 13Z'
          fill='#121826'
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DuplicateIconV1;
